import * as React from "react";
import Icon from "~/components/icons/icon";
import classNames from "classnames";
import { IBaseLink } from "~/types/link";

export interface INavigationDropdownSectionProps extends IBaseLink {
    className?: string;
}

const NavigationDropdownSection: React.SFC<INavigationDropdownSectionProps> = props => {
    const rootclasses = classNames("navigation-dropdown__section", props.className);

    return (
        <div className={rootclasses}>
            <div className="navigation-dropdown__section-header">
                <a className="navigation-dropdown__section-link" href={props.url} target={props.target}>
                    {props.label}
                    <Icon iconId="icon_16_arrow-right-bold" />
                </a>
            </div>
            {props.children}
        </div>
    );
};

export default NavigationDropdownSection;
